import Modal from './modal';

class ModalDefault {
	constructor(el, opts = {}) {
		this.el = el;
		this.opts = opts;

		if (!this.el || this.el.getAttribute('data-modal-initialized')) {
			return;
		}

		const contentEl = this.el.querySelector('.js__modal--default-content');

		if (!contentEl) {
			return;
		}

		this.modalContent = contentEl.innerHTML;
		this.el.setAttribute('data-modal-initialized', 'true');
		this.initializeModals();
	}

	initializeModals = () => {
		this.el.addEventListener('click', () => {
			Modal.show(
				this.modalContent,
				this.opts
			);
		});
	};

}

export default ModalDefault;
